<div class="flex items-center gap-3">
    <!-- <p-button [icon]="menuIconItem.icon"
              class="p-button-text"
              [styleClass]="menuIconItem.styleClass"
              (click)="menuIconItem.command?.({originalEvent: $event, item: menuIconItem})">
    </p-button> -->


    <i class="pi pi-bars cursor-pointer" style="font-size: 1rem" (click)="menuIconItem.command?.({originalEvent: $event, item: menuIconItem})" ></i>
    <p-breadcrumb [model]="items" [home]="home"></p-breadcrumb>
</div>
